'use client'

import { AppRouterCacheProvider } from '@mui/material-nextjs/v16-appRouter'
import { DECLARATION, prefixer } from 'stylis'
import rtlPlugin from 'stylis-plugin-rtl'

// Types
import type { Middleware } from 'stylis'
import type { NextjsProviderProps } from '@/types/components/providers/nextjs'

// Properties that still need a vendor prefix in current Safari; the full prefixer adds old flexbox and keyframe copies
// to every rule, which made the inline CSS of each page about a third bigger
const PREFIXED = /^(user-select|backdrop-filter|appearance|text-size-adjust|background-clip|box-decoration-break)$/

const lightPrefixer: Middleware = (element, index, children, callback) => {
	if (element.type === DECLARATION && PREFIXED.test(element.props as string)) return prefixer(element, index, children, callback)
}

const NextjsProvider = (props: NextjsProviderProps) => {
	// Props
	const { dir, children } = props

	return <AppRouterCacheProvider options={{ stylisPlugins: dir == 'rtl' ? [lightPrefixer, rtlPlugin] : [lightPrefixer] }}>{children}</AppRouterCacheProvider>
}

export default NextjsProvider
